import * as React from "react"
import { Col, Container, Row } from "react-grid-system"
import Subtitle from "../../atoms/typography/Subtitle"
import { HorizontalSpacer } from "../../atoms/spacers"
import Body from "../../atoms/typography/Body"
import ColorfulButton from "../../atoms/buttons/ColorfulButton"
import { RequestDemoButton } from "../../molecules/store/RequestDemo"
import { Link } from "react-router-dom"

const EmptyDashboardPage: React.FC = () => {
  return (
    <div>
      <HorizontalSpacer spacing={3} />
      <Row>
        <Col lg={3} />
        <Col lg={6}>
          <Subtitle textAlign="center">There is nothing here yet...</Subtitle>
          <HorizontalSpacer spacing={2} />
          <Body>
            The dashboard is as a central hub enabling seamless management and oversight of all your Satcube terminals.
          </Body>
          <HorizontalSpacer spacing={1} />
          <Body>In the dashboard you can:</Body>
          <Body>・ Get an overview of terminals, groups and dataplans</Body>
          <Body>・ Gather detailed dataplan usage statistics</Body>
          <Body>・ Find terminal information and security details</Body>
          <Body>・ See groups, groupmembers and their terminals</Body>
          <Body>・ Create reports of terminal usage based on dataplans or groups</Body>
          <Body>・ Top - up data</Body>
          <Body>・ and much more to come. Contact sales@satcube.com to learn more.</Body>
          <HorizontalSpacer spacing={2} />
          <Body>
            If your organization has terminals which are not displayed here contact us and we’ll help you get started!
            Still haven’t gotten your hands on a Satcube terminal? Browse our store to see our solutions, or book a demo
            and we’ll show you what we can offer!
          </Body>
          <HorizontalSpacer spacing={6} />
          <Row justify="between" nogutter>
            <RequestDemoButton productType="our product" buttonType="colorblue" />
            <Link to="/contact">
              <ColorfulButton variant="blue" title="Contact us" />
            </Link>
          </Row>
        </Col>
        <Col lg={3} />
      </Row>
    </div>
  )
}

export default EmptyDashboardPage
